import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
 
  /**
   * Description: Método que llama el servicio web de obtener datos basicos de un usuario
   * Autor: Diego Diaz
   * @param customerAccountId identificador de la cuenta
   * @return Mensaje de confirmación de la validación
   */
  getPendingTickets(customerAccountId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(
      constants.ENDPOINT_TICKET_GET_BY_DOCUMENT_STATES, 
      { "customerAccountId": customerAccountId, state: [] }
    );
  }

}
